@if (measure && (currentUser$ | async); as user) {
  <div class="container">
    <!------- Header ------->
    <div class="header"
      [ngClass]="(isExpanded$ | async) ? 'header-expanded' : 'header-collapsed'">
      <div class="header-left">
        <div class="info">
          <div class="title">{{measure.name}}</div>
          @if (measure.straightMeasure) {
            <div class="sub-title">{{'straight_line_distance' | transloco}}</div>
          }
          @if (measure.areaVolume) {
            <div class="sub-title">{{'area_and_volume' | transloco}}</div>
          }
          <div class="sub-title">{{measure.center | wgs84}}</div>
        </div>
      </div>
      <div class="header-actions">
        @if (!(isExpanded$ | async)) {
          <button mat-icon-button
            matTooltip="{{'expand' | transloco}}"
            (click)="onClickExpand()">expand_content
          </button>
        }
        @if ((isExpanded$ | async)) {
          <button mat-icon-button
            matTooltip="{{'collapse' | transloco}}"
            (click)="onClickCollapse()">collapse_content
          </button>
        }
        <button mat-icon-button
          matTooltip="{{'close' | transloco}}"
          (click)="onClickClose()">close
        </button>
      </div>
    </div>
    <!------- Content ------->
    <div class="content"
      [ngClass]="(isExpanded$ | async) ? 'content-expanded' : 'content-collapsed'">
      <div class="main"
        [ngClass]="(isExpanded$ | async) ? 'main-expanded' : 'main-collapsed'">
        @if (measure.straightMeasure) {
          <div>
            <div [ngClass]="{'row': (isExpanded$ | async), 'col': !(isExpanded$ | async)}">
              <div class="section-title">{{'direct_distance' | transloco | uppercase}} :</div>
              <div class="indicators">{{ measure.straightMeasure.directDistance.toFixed(2)}} m</div>
            </div>
            <div [ngClass]="{'row': (isExpanded$ | async), 'col': !(isExpanded$ | async)}">
              <div class="section-title">{{'distance_follwing_the_terrain_from_above' | transloco | uppercase}} :</div>
              <div class="indicators">{{ measure.straightMeasure.topTerrainDistance.toFixed(2)}} m</div>
            </div>
            <div [ngClass]="{'row': (isExpanded$ | async), 'col': !(isExpanded$ | async)}">
              <div class="section-title">{{'distance_follwing_the_ground_from_the_front' | transloco | uppercase}} :</div>
              <div class="indicators">{{ measure.straightMeasure.faceTerrainDistance.toFixed(2)}} m</div>
            </div>
          </div>
        }
        @if (measure.areaVolume) {
          <div>
            <div [ngClass]="{'row': (isExpanded$ | async), 'col': !(isExpanded$ | async)}">
              <div class="section-title">{{'projected_area' | transloco | uppercase}} :</div>
              <div class="indicators">{{ measure.areaVolume.projectedArea.toFixed(2)}} m2</div>
            </div>
            <div [ngClass]="{'row': (isExpanded$ | async), 'col': !(isExpanded$ | async)}">
              <div class="section-title">{{'estimate_of_actual_area' | transloco | uppercase}} :</div>
              <div class="indicators">{{ measure.areaVolume.terrainArea.toFixed(2)}} m2</div>
            </div>
            <div [ngClass]="{'row': (isExpanded$ | async), 'col': !(isExpanded$ | async)}">
              <div class="section-title">{{'full_volume_above_the_average_plan' | transloco | uppercase}} :</div>
              <div class="indicators">{{ measure.areaVolume.upFullVolume.toFixed(2)}} m3</div>
            </div>
            <div [ngClass]="{'row': (isExpanded$ | async), 'col': !(isExpanded$ | async)}">
              <div class="section-title">{{'full_volume_below_the_average_plan' | transloco | uppercase}} :</div>
              <div class="indicators">{{ measure.areaVolume.downFullVolume.toFixed(2)}} m3</div>
            </div>
            <div [ngClass]="{'row': (isExpanded$ | async), 'col': !(isExpanded$ | async)}">
              <div class="section-title">{{'empty_volume_below_average_plan' | transloco | uppercase}} :</div>
              <div class="indicators">{{ measure.areaVolume.downEmptyVolume.toFixed(2)}} m3</div>
            </div>
          </div>
        }
        <div style="display: flex; flex: 1 1 auto">
        </div>
        <!------- Actions ------->
        <div class="actions">
          @if (!(isExpanded$ | async)) {
            <button
              mat-icon-button
              matTooltip="{{'move_the_camera_on_the_measure' | transloco}}"
              (click)="onClickFlyTo(measure)">my_location
            </button>
          }
          @if (user.name == measure.author) {
            <button
              mat-icon-button
              matTooltip="{{'rename' | transloco}}"
              (click)="onClickRename(measure)"><mat-icon>edit</mat-icon></button>
            }
            @if (!measure.isShared && user.name == measure.author) {
              <button
                mat-icon-button
                matTooltip="{{'share' | transloco}}"
                (click)="onClickToggleShare(measure)">
                <mat-icon>share</mat-icon>
              </button>
            }
            @if (measure.isShared && user.name == measure.author) {
              <button
                mat-icon-button
                matTooltip="{{'share_off' | transloco}}"
                (click)="onClickToggleShare(measure)">
                <mat-icon>share_off</mat-icon>
              </button>
            }
            @if (!(isExpanded$ | async)) {
              <button
                mat-icon-button
                [matTooltip]="(measure.show ? 'hide_overlay' : 'show_overlay') | transloco"
                [disabled]="!(displayMeasures$ | async)"
                (click)="onClickToggleShow(measure)">
                <mat-icon>
                  {{ measure.show ? 'visibility' : 'visibility_off' }}
                </mat-icon>
              </button>
            }
            <span class="spacer"></span>
            @if (user.name == measure.author) {
              <button
                style="color: var(--warn-color)"
                mat-icon-button
                matTooltip="{{'delete' | transloco}}"
                (click)="onClickDelete(measure)">delete
              </button>
            }
          </div>
        </div>
        <div class="side"
          [ngClass]="(isExpanded$ | async) ? 'side-expanded' : 'side-collapsed'">
          <!--      <div *ngIf="user.name != measure.author" class="author">{{'created_by_f' | transloco }} {{measure.author}}</div>-->
          <!------- History ------->
          <measure-history-channel class="history" [itemId]="measure.id"></measure-history-channel>
        </div>
      </div>
    </div>
  }
